module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Network_16"],"polygon":[{"$":{"points":"15 11 15 7 8 7 8 4 11 4 11 0 4 0 4 4 7 4 7 7 1 7 1 11 0 11 0 15 4 15 4 11 2 11 2 8 7 8 7 11 6 11 6 15 10 15 10 11 8 11 8 8 14 8 14 11 12 11 12 15 16 15 16 11 15 11","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Network_16.svg
// module id = wnS6
// module chunks = 1